/** @file Sibling index that sorts a bone last under a parent (one past the largest; gaps are kept). */
import type { Doc, Id } from '@pose2d/format/types';

/** One past the largest siblingIndex among the current children of `parent` in `doc` (0 when it has none). */
export function nextSiblingIndex(doc: Doc, parent: Id): number {
  let next = 0;
  for (const bone of Object.values(doc.bones)) if (bone.parent === parent && bone.siblingIndex >= next) next = bone.siblingIndex + 1;
  return next;
}
